import theme from '../theme/theme';
import { commands } from './index';

const {
  Icons: { quickLinks },
} = theme;

const {
  homeCommand,
  workCommand,
  favoritesCommand,
  recentsCommand,
  parkingCommand,
  fuelCommand,
  foodCommand,
  hospitalsCommand,
} = commands;

export const QuickLinks = [
  {
    name: 'home',
    icon: quickLinks.Home,
    message: homeCommand,
  },

  {
    name: 'work',
    icon: quickLinks.Work,
    message: workCommand,
  },

  {
    name: 'favorites',
    icon: quickLinks.FavoritesFilled,
    message: favoritesCommand,
  },

  {
    name: 'recents',
    icon: quickLinks.Recent,
    message: recentsCommand,
  },

  {
    name: 'parking',
    icon: quickLinks.Parking,
    message: parkingCommand,
  },

  {
    name: 'fuel',
    icon: quickLinks.Fuel,
    message: fuelCommand,
  },

  {
    name: 'food',
    icon: quickLinks.Food,
    message: foodCommand,
  },

  {
    name: 'hospitals',
    icon: quickLinks.Hospital,
    message: hospitalsCommand,
  },
];
